import { useEffect, useRef } from "react";

import { GenericObject } from "@vahak/core/dist/custom-types/generic-object";

import { TrackEventHandler } from "../../../types/events";

/** Fire a page-open WEB_V2 event once on mount. */
export function useWebV2PageOpened(trackEvent?: TrackEventHandler, eventName?: string, eventData?: GenericObject) {
    const firedRef = useRef(false);

    useEffect(() => {
        if (!trackEvent || !eventName || firedRef.current) {
            return;
        }
        firedRef.current = true;
        trackEvent(eventName, eventData);
    }, [eventData, eventName, trackEvent]);
}
